module.exports = __webpack_public_path__ + "img/welcome_bg.e795f519.jpg";